import { Paper } from '@mantine/core';
import classNames from './Paper.module.css';

export default Paper.extend({
  classNames,
});
